import { useIntl } from 'react-intl';

import { Helmet } from '@xing-com/crate-helmet';

export type HeadProps = {
  titleTranslationKey?: string;
  descriptionTranslationKey?: string;
};

export const Head: React.FC<HeadProps> = ({
  titleTranslationKey,
  descriptionTranslationKey,
}) => {
  const { formatMessage } = useIntl();

  const title = formatMessage({
    id: titleTranslationKey ? titleTranslationKey : 'CAREER_HUB_META_TITLE',
  });
  const description = formatMessage({
    id: descriptionTranslationKey
      ? descriptionTranslationKey
      : 'CAREER_HUB_META_DESCRIPTION',
  });

  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta name="twitter:title" content={title}></meta>

      <meta name="description" content={description} />
      <meta property="og:description" content={description}></meta>
      <meta name="twitter:description" content={description}></meta>

      <meta name="robots" content="index,follow" />
    </Helmet>
  );
};
